<template>
  <div class="put_order_form">
    <put-scheme v-if="!isSmallSn" class="charge_way" @change="changeChargeWay"></put-scheme>

    <el-form label-width="86px" class="must">
      <el-form-item label="投放城市">
        <MultCityAsync @change="getAddressCodesFirst"></MultCityAsync>
      </el-form-item>
      <el-form-item label="投放日期" size="mini">
        <template v-if="chargeWay == 'cpmL'">
          <el-date-picker class="input-date" v-model="startDateCpmL" value-format="yyyy-MM-dd" :clearable="false" type="date" :picker-options="startPickerOptions"></el-date-picker>
          <i class="iconfont icon-biaodan-shijian fr"></i>
        </template>
        <SearchTime v-else v-model="searchTime"></SearchTime>
      </el-form-item>
      <el-form-item label="投放时段">
        <el-popover placement="bottom" trigger="click" popper-class="time-slot" @show="showTime = !showTime" @hide="showTime = !showTime">
          <div class="time-area" slot="reference">
            <span class="fl els">{{ timeStr }}</span>
            <i class="fr el-icon-arrow-down" :class="{ up: showTime }"></i>
          </div>
          <SearchTimeRange @submit="timeConfirm" :isInit="true" ref="timeRangeRef"></SearchTimeRange>
        </el-popover>
      </el-form-item>
      <el-form-item label="单次曝光">
        <SearchSelectAdvTime v-model="searchCondition.contentTime"></SearchSelectAdvTime>
      </el-form-item>
    </el-form>
    <TargetLabelFlow v-if="chargeWay.indexOf('cpm') > -1" isImport :mode="chargeWay" v-model="targetFlowData"> </TargetLabelFlow>
    <el-form label-width="86px" v-if="chargeWay != 'pkg'">
      <el-form-item class="must custom" label="合同编码">
        <el-input placeholder="请输入正确的合同编码" :maxlength="30" v-model="searchCondition.contractNo">
          <i slot="suffix" class="iconfont icon-biaodan-tianxie"></i>
        </el-input>
      </el-form-item>
      <!-- 小屏投放不加【展现位置】 -->
      <!-- <el-form-item v-if="!isSmallSn" class="must custom" label="展现位置">
        <el-select placeholder="选择展现位置" popper-class="form_pop" v-model="searchCondition.displayRegion">
          <el-option v-for="reg in displayRegions" :key="reg.value" :label="reg.label" :value="reg.value"></el-option>
        </el-select>
      </el-form-item> -->
    </el-form>
    <el-form label-width="86px">
      <!--新禁播标签-->
      <el-form-item  class="custom" label="禁播标签">
        <!--        <el-select placeholder="选择禁播标签" popper-class="form_pop" v-model="searchCondition.noPlayingLabels" multiple>-->
        <!--          <el-option v-for="item in noPlayingLabels" :key="item.dictItemCode" :label="item.dictItemName" :value="item.dictItemName" ></el-option>-->
        <!--        </el-select>-->
        <NoPlayingLabelSelector  v-model="searchCondition.noPlayingLabels"></NoPlayingLabelSelector>
      </el-form-item>
    </el-form>

    <el-button type="default" plain class="btn download_btn" icon="iconfont icon-download-template" @click="downloadTemplate">下载Excel模板</el-button>
    <el-upload
      class="upload_btn"
      accept=".xlsx"
      name="file"
      :headers="upHeaders"
      :disabled="disable"
      :show-file-list="false"
      :with-credentials="true"
      :action="config.importExcel"
      :before-upload="beforeUpload"
      :on-progress="uploadProgress"
      :on-success="uploadSuccess">
      <el-button type="primary" class="btn import_btn" :class="{'is-disabled':disable}" icon="iconfont icon-shangchuananniu">
        {{ importStatus === 2 ? '重新上传Excel文件' : '导入Excel文件' }}
      </el-button>
    </el-upload>
    <span class="txt_sub">仅支持xlsx格式，大小不超过6MB</span>
  </div>
</template>

<script>
import SearchTime from './MySearchTime'
import SearchSelectAdvTime from './MySearchSelectAdvTime'
import PutScheme from '@/views/PutOrder/components/OrderForm/PutScheme'
import TargetLabelFlow from './OrderForm/TargetLabelFlow'
import SearchTimeRange from '@/components/SearchTimeRange'
import { ChargeWayEnum } from '@/views/PutOrder/config.js'
import NoPlayingLabelSelector from "@/components/NoPlayingLabelSelector";

const dayMs = 24 * 3600000
const dateNow = new Date()

export default {
  name: 'ImportCondition',
  components: {NoPlayingLabelSelector, SearchTime, SearchSelectAdvTime, TargetLabelFlow, PutScheme, SearchTimeRange },
  props: {
    config: {
      type: Object,
      default() {
        return {}
      }
    },
    importStatus: {
      type: Number,
      default: 0
    }
  },
  data() {
    let td = this.getDateStr(new Date(dateNow.getTime() + 2 * dayMs))
    return {
      fileObj: { name: '', progress: 0 },
      searchTime: [],
      searchCondition: {
        advertType: '',
        contentTime: '',
        startDate: '',
        endDate: '',
        addressCodes: [],
        packageInfoCodes: [],
        clienteleName: '',
        contractNo: '',
        displayRegion: 1,
        noPlayingLabels:[]
      },
      startDateCpmL: td,
      importResultData: [],
      labelListPayway: [],
      chargeWay: '',
      targetFlowData: { targetFlowOrbudgetAmount: '', chooseLabel: [] },
      isCpReady: false, // 防止数据初始化的时候 searchCondition的watch导致触发search
      reqArr: [],
      startPickerOptions: {
        disabledDate(t) {
          const dt = new Date(t)
          return dt - dateNow < -dayMs || dt - dateNow > 92 * dayMs
        }
      },

      timeStr: '',
      searchTimeRange: [], // 投放时段
      showTime: false
    }
  },
  computed: {
    isSmallSn() { // 是否是小屏投放或小屏导入点位
      let name = this.$store.state.order.conditionSearchTypeName
      return name.toLowerCase().indexOf('smallsn') > -1
    },
    upHeaders() {
      return {
        token: localStorage.getItem('user_ticket') || undefined
      }
    },
    disable() {
      const { advertType } = this.searchCondition
      return (!this.isSmallSn && !advertType)
    },
    noPlayingLabels(){
      return this.$store.state.common['NEW_NO_PLAY_LABLE']
    }
  },
  watch: {
    labelListPayway(v) {
      // 收费方式变化
      if (v && v[0]) {
        let payWay = v[0]
        this.chargeWay = ChargeWayEnum[payWay] || 'cpd'
        this.chargeWayChange()
      }
      this.chargeWayParamChange()
    },
    startDateCpmL(v) {
      this.searchCondition.startDate = v
    },
    searchTime(o) {
      if (!o || o.length < 2) return
      this.searchCondition.startDate = o[0]
      this.searchCondition.endDate = o[1]
    },
    searchCondition: {
      deep: true,
      handler(nv) {
        this.handleReqDelay()
      }
    },
    targetFlowData: {
      deep: true,
      handler(v) {
        this.chargeWayParamChange()
        this.handleReqDelay()
      }
    },
    importStatus(val) {
      this.$emit('update:importStatus', val)
    },
    reqArr(v) {
      // 触发一个可能导致其他变化多次触发search请求  此处增加 reqArr 检测来延迟控制发送请求
      if (v.length == 0) {
        this.search()
      }
    }
  },
  created() {
    if (this.isSmallSn) {
      this.searchCondition.displayRegion = 2
    }
  },
  methods: {
    changeChargeWay(type, res) {
      let opt = this.searchCondition
      if (type === 'user') {
        let { customerId, customerName, id } = res
        opt.customerId = customerId || ''
        opt.clienteleName = customerName || ''
        opt.userId = id || ''
        opt.choosePkg = {}
        opt.packageInfoCodes = []
      } else if (type === 'pkg') {
        let { data, num } = res
        opt.choosePkg = data
        opt.choosePkg.num = num
        opt.packageInfoCodes = data.packageInfoCodes.slice(0, num)
        opt.pkgChooseFlow = num * (data.reachPersons || 0) // 选择套餐码对应的人流数量
        this.handleReqDelay()
      } else if (type === 'putscheme') {
        this.labelListPayway = res
        delete opt.clienteleName
        delete opt.choosePkg
        delete opt.packageInfoCodes
        delete opt.customerId
        delete opt.userId
      } else if (type === 'adtype') {
        opt.advertType = res[0]
      }
    },
    timeConfirm(data) {
      let list = data.data || []
      this.timeStr = list.map((el) => el.frequencyName).join('、')
      this.searchTimeRange = list
      this.searchCondition.searchTimeRange = list
      this.searchCondition.timeSegmentType = data.type
      this.handleReqDelay()
    },
    chargeWayParamChange() {
      // 预算金额\目标流量对应的传参
      let chargeType = this.labelListPayway[0]
      let targetLabel = this.targetFlowData.chooseLabel[0]
      let chargeTarget = targetLabel ? [chargeType, targetLabel] : chargeType ? [chargeType] : []
      this.searchCondition.orderLabels = chargeTarget
    },
    chargeWayChange() {
      let v = this.chargeWay
      if (v == 'cpmL') {
        // 投放开始结束时间处理
        this.searchCondition.startDate = this.startDateCpmL
        this.searchCondition.endDate = ''
      } else {
        // 投放开始结束时间处理
        this.searchCondition.startDate = this.searchTime[0]
        this.searchCondition.endDate = this.searchTime[1]

        if (v == 'cpd') {
          // 预计金额 目标流量处理
          this.targetFlowData = { targetFlowOrbudgetAmount: '', chooseLabel: [] }
        } else if (v == 'pkg') {
          // 选择【套餐兑换】后需将【展现位置】设置为主屏
          this.searchCondition.displayRegion = 1
          // 套餐不传合同编码
          this.searchCondition.contractNo = ''
          delete this.searchCondition.contractNo
        }
      }
    },
    getAddressCodesFirst(res, initData) {
      if (initData) {
        this.searchCondition.addressCodes = initData
        return
      }
      let addressCodesParam = this.rmCheckItemChilds(res)
      this.searchCondition.addressCodes = addressCodesParam.map((el) => el.split('^^').join('.')).map((el) => (el.indexOf('.') < 0 ? el + '.' : el))
    },
    rmCheckItemChilds(res) {
      // 去除已选数据的子集数据：比如杭州市是选中状态，滨江区等区域选中的数据就不传参了
      let data = []
      let final = res.map((el) => el.ids).sort()
      final.forEach((item) => {
        data.forEach((el) => {
          if ((item + '').indexOf(el) > -1) item = null
        })
        if (item) data.push(item + '')
      })
      return data
    },
    handleReqDelay() {
      this.reqArr.push(1)
      const t = setTimeout(() => {
        clearTimeout(t)
        if (this.reqArr.length > 0) this.reqArr.splice(this.reqArr.length - 1, 1)
      }, 400)
    },
    testParams() {
      if (!this.isSmallSn && !this.labelListPayway.length) return this.messageTip('请选择收费方式', 2)

      let condition = this.searchCondition

      if (this.chargeWay == 'pkg') {
        if (!condition.userId) return this.messageTip('请选择客户/用户', 2) // 客户/用户数据 判断用户id就行 有用户 客户肯定有
        if (condition.packageInfoCodes.length == 0) return this.messageTip('请选择套餐码', 2) // 套餐码
        if (!condition.clienteleName || condition.clienteleName.trim() == '') return this.messageTip('请输入客户名称', 2)
        if (!condition.addressCodes || !condition.addressCodes.length) return this.messageTip('请选择投放城市', 2)
      }

      if (!condition.addressCodes || !condition.addressCodes.length) return this.messageTip('请选择投放城市', 2)
      let targetFlowOrbudgetAmount = ((this.targetFlowData.targetFlowOrbudgetAmount || '') + '').trim()
      if (this.chargeWay == 'cpmL') {
        if (!targetFlowOrbudgetAmount) return this.messageTip('请填写触达总量后再查找电梯广告', 2)
      } else if (this.chargeWay == 'cpmT') {
      }

      if (this.chargeWay !== 'pkg') {
        const contract = (condition.contractNo || '').trim()
        if (!contract) return this.messageTip('请输入合同编码', 2)
        condition.contractNo = contract
      }

      return true
    },
    getDateStr(date) {
      date = date || dateNow
      return date.format().slice(0, 10)
    },
    async downloadTemplate() {
      await this.$exportGet(this.config.uploadTemplate)
    },
    beforeUpload(file) {
      if (file.size > 6 * 1024 * 1024) {
        this.$message.warning('文件大小超出限制')
        return false
      }
      if (!this.testParams()) return false
      this.fileObj.name = file.name
      this.fileObj.process = 0
      this.$emit('update:importStatus', 1)

      // 控制导入文件之后才能执行search方法
      this.isCpReady = true
    },
    uploadSuccess(response, file, fileList) {
      this.$emit('update:importStatus', 2)
      this.fileObj.name = ''
      this.fileObj.process = 0
      if (response.code === 0) {
        this.importResultData = response.data
        this.search()
      } else {
        this.$message.error(response.message || response.msg)
        this.importResultData = []
      }
    },
    search() {
      if (!this.isCpReady) return
      if (!this.testParams()) return false
      this.$store.commit('order/setPayWay', this.chargeWay)
      this.searchCondition.targetFlowData = this.targetFlowData
      this.$emit('search', {
        condition: this.searchCondition,
        result: this.importResultData
      })
    },
    uploadProgress(event, file, fileList) {
      this.fileObj.progress = event.percent
      this.$emit('progress', this.fileObj)
    }
  },
  beforeDestroy() {
    this.isCpReady = false
  }
}
</script>

<style lang="scss" scoped>
.charge_way {
  ::v-deep .search_item {
    &.must {
      .label {
        &::before {
          display: none;
        }
      }
    }
  }

  ::v-deep .label-slt {
    .el-form-item__label {
      padding-left: 0;
    }
  }
}

::v-deep .el-form {
  &.must {
    label {
      color: #282729;

      &::before {
        left: 14px;
      }
    }
  }

  .el-range-editor--mini {
    .el-range-input {
      width: 76px;
      font-size: 14px;
      text-align: left;
    }

    .el-range-separator {
      width: 25px;
    }
  }
}

.time-area {
  float: right;
  width: 220px;
  height: 28px;
  line-height: 28px;
  cursor: pointer;
  margin-top: 5px;

  span {
    width: 192px;
    display: inline-block;
  }

  i {
    margin-left: 4px;
    margin-right: 10px;
    margin-top: 9px;
    color: #c0c4cc;

    &.up {
      transform: rotate(180deg);
    }
  }
}

.el-icon-arrow-down {
  margin-right: 10px;
  margin-top: 14px;
  color: #c0c4cc;
}

.input-date {
  width: 180px;
  line-height: 40px;
  display: inline-block;

  ::v-deep input {
    border: none;
    padding: 0 15px;
  }

  ::v-deep .el-input__prefix {
    display: none;
  }
}

.put_order_form {
  margin: 20px;

  .custom {
    ::v-deep .el-input {
      font-size: 12px;
      padding-right: 25px;
      width: 220px;

      input {
        border: none;
        padding-right: 0;

        &:focus {
          border-bottom: none !important;
        }
      }

      .el-input__prefix {
        display: none;
      }
    }
  }

  .el-form-item {
    margin-bottom: 20px;
    border: 1px solid #e9e9e9;
    border-radius: 4px;
    min-height: 40px;
  }

  ::v-deep .el-form-item__label {
    line-height: 20px;
    margin: 9px 0;
    border-right: 1px solid #e9e9e9;
    text-align: left;
    padding: 0;
    color: #282729;
    padding-left: 17px;
  }

  ::v-deep .el-form-item__content {
    line-height: 38px;
  }

  .must {
    ::v-deep .el-form-item__label {
      &:before {
        left: 12px;
      }
    }
  }

  .el-input__inner {
    border: none !important;
  }

  .download_btn {
    width: 100%;
    margin-top: 10px;
    color: #ff3973;
    border: 1px solid #ff3973;
    padding: 10px 20px;
    ::v-deep .icon-download-template {
      font-size: 15px;
    }
    &:hover {
      color: #ff3973;
      border: 1px solid #ff3973;
    }
  }

  .import_btn {
    width: 100%;
    margin-left: 0;
    background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%);
    border: none;
    &.is-disabled {
      background: #c0c4cc;
    }
  }

  .upload_btn {
    margin-top: 10px;
    ::v-deep .el-upload {
      display: block;
    }
  }

  .txt_sub {
    display: block;
    text-align: center;
    margin-top: 10px;
    color: #999;
    font-size: 12px;
    line-height: 17px;
  }
}
</style>
